module.exports = __webpack_public_path__ + "static/media/php-logo.63bedf90.png";